import {
  FaCheckCircle,
  FaHandsHelping,
  FaHome,
  FaPills,
  FaUserFriends,
  FaUserNurse,
  FaUtensils,
} from 'react-icons/fa';

const serviceCards = [
  {
    title: 'Personal Care Assistance',
    text: 'Support with bathing, grooming, dressing, toileting, and mobility for participants who need daily living assistance.',
    icon: FaUserNurse,
  },
  {
    title: 'Companionship and Supervision',
    text: 'Friendly social support, safety monitoring, and routine check-ins to reduce isolation and improve quality of life.',
    icon: FaUserFriends,
  },
  {
    title: 'Medication Support',
    text: 'Non-clinical medication reminders and observation to help participants stay on schedule safely.',
    icon: FaPills,
  },
  {
    title: 'Meal Planning and Nutrition',
    text: 'Meal prep based on dietary needs, hydration reminders, and feeding support when required.',
    icon: FaUtensils,
  },
  {
    title: 'Homemaking and Errands',
    text: 'Light housekeeping, laundry, grocery runs, and home organization to maintain a healthy home environment.',
    icon: FaHome,
  },
  {
    title: 'Respite Care for Families',
    text: 'Temporary caregiver relief so family members can rest, work, or attend important responsibilities.',
    icon: FaHandsHelping,
  },
];

const eligiblePrograms = [
  'Participants referred through Medicaid waiver and community-based care pathways',
  'Older adults who need in-home support to remain independent safely',
  'Adults with long-term disabilities or chronic health limitations',
  'Families seeking respite and supervised support for loved ones',
];

export default function ServicesPage() {
  return (
    <>
      <section className="bg-white py-16">
        <div className="mero-wrapper relative overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-r from-teal-50 to-cyan-50 p-8 md:p-10">
          <div className="pointer-events-none absolute -right-20 -top-16 h-64 w-64 rounded-full bg-cyan-200/60 blur-3xl" />
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-teal-700">
            Our Services
          </p>
          <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-900">
            Home care tailored for eligible participants
          </h1>
          <p className="mt-5 max-w-4xl text-slate-600">
            We provide high-quality home care services that help eligible
            participants maintain comfort, dignity, and independence in their
            own homes. Every care plan is customized to the participant's
            medical, functional, and personal needs.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="mero-wrapper grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {serviceCards.map((service) => {
            const Icon = service.icon;

            return (
            <article
              key={service.title}
              className="group rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-md"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-teal-100 text-teal-700 transition group-hover:bg-teal-700 group-hover:text-white">
                <Icon />
              </span>
              <h2 className="text-lg font-semibold text-teal-800">{service.title}</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">{service.text}</p>
            </article>
            );
          })}
        </div>
      </section>

      <section className="relative overflow-hidden bg-slate-900 py-16 text-slate-100">
        <div className="pointer-events-none absolute -left-16 top-6 h-56 w-56 rounded-full bg-teal-500/20 blur-3xl" />
        <div className="pointer-events-none absolute -right-16 bottom-6 h-56 w-56 rounded-full bg-cyan-500/20 blur-3xl" />
        <div className="mero-wrapper grid gap-8 lg:grid-cols-[1fr_1fr] lg:items-center">
          <div>
            <h2 className="text-2xl font-bold text-white">Who may be eligible?</h2>
            <p className="mt-3 text-slate-300">
              Eligibility is determined by care need level, program enrollment,
              and assessment outcomes. Our office can help you understand next
              steps and required documentation.
            </p>
          </div>

          <ul className="space-y-3 rounded-2xl border border-white/20 bg-white/10 p-6 backdrop-blur">
            {eligiblePrograms.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm leading-6">
                <FaCheckCircle className="mt-1 text-teal-300" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
